const newColors: string[] = [
  '#00C2FF',
  '#0075FF',
  '#0045C6',
  '#FF4141',
  '#D70000',
  '#A90000',
  '#FFC700',
  '#E89900',
  '#C86000',
  '#33F103',
  '#26BE00',
  '#1B8701',
];

const oldColors: string[] = ['#FF7364', '#FFB85B', '#76C8FD', '#47C5A2', '#52586D'];

function getColorHEX(number: number): string {
  switch (number) {
    case 1:
      return oldColors[0];
    case 2:
      return oldColors[1];
    case 3:
      return oldColors[2];
    case 4:
      return oldColors[3];
    case 5:
      return oldColors[4];
    case 11:
      return newColors[0];
    case 12:
      return newColors[1];
    case 13:
      return newColors[2];
    case 14:
      return newColors[3];
    case 15:
      return newColors[4];
    case 16:
      return newColors[5];
    case 17:
      return newColors[6];
    case 18:
      return newColors[7];
    case 19:
      return newColors[8];
    case 20:
      return newColors[9];
    case 21:
      return newColors[10];
    case 22:
      return newColors[11];
    default:
      return 'white';
  }
}

export { newColors, oldColors, getColorHEX };
